"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const AppButton_vue_1 = __importDefault(require("@/client/components/common/AppButton.vue"));
const SelectPlayerRow_vue_1 = __importDefault(require("@/client/components/SelectPlayerRow.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'SelectDelegate',
    props: {
        players: {
            type: Array,
            required: true,
        },
        playerinput: {
            type: Object,
            required: true,
        },
        onsave: {
            type: Function,
            required: true,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data() {
        return {
            selectedPlayer: undefined,
        };
    },
    components: {
        AppButton: AppButton_vue_1.default,
        'select-player-row': SelectPlayerRow_vue_1.default,
    },
    methods: {
        saveData() {
            if (this.selectedPlayer !== undefined) {
                this.onsave({ type: 'delegate', player: this.selectedPlayer });
            }
        },
    },
});
